// animated bottom panel for selections (similar to dropdown)
// defaults to partial height or can be forced to full height
// only supports one active panel at a time, other panels will be closed
// pass CSS-based selector, ID is best, of element to be made active
function alkBottomPanel(element) {
	var openedClass = 'alk-bottom-panel-opened';
	var openedSelector = `.${openedClass}`;
	var $element = document.querySelector(element);
	var $body = document.body;
	var $openedBottomPanels;

	if ($element === null) {
		console.log('ERROR: element cannot be found!');
		return false;
	}

	// check for blocker
	var $blocker = document.querySelector('.alk-bottom-panel-blocker');
	if ($blocker === null) {
		$body.insertAdjacentHTML('beforeend', '<div class="alk-bottom-panel-blocker"></div>');
		$blocker = document.querySelector('.alk-bottom-panel-blocker');
	}

	// check to make sure it's a valid element
	if ($element.classList.contains('alk-bottom-panel')) {
		var isPanelOpen = $element.classList.contains(openedClass);
		// check for active panel
		$openedBottomPanels = document.querySelectorAll(openedSelector);
		if ($openedBottomPanels.length) {
			Array.from($openedBottomPanels).forEach(
				(p) => p.classList.remove(openedClass)
			);
		}

		if (isPanelOpen) {
			// there is no active panel or
			// active panel is the one just set in motion
			// therefore toggle classes as expected
			$element.setAttribute('aria-hidden', 'true');
			$blocker.classList.remove('alk-bottom-panel-blocker-show');
			$element.classList.remove(openedClass);
		} else {
			// there is already an active panel as new one is activated
			// therefore close the initial panel
			// note: this should always be one element but we go with "all" just in case
			// show newly activated panel
			$element.setAttribute('aria-hidden', 'false');
			$blocker.classList.add('alk-bottom-panel-blocker-show');
			$element.classList.add(openedClass);
		}
	}
}

function formatCurrency(decimal) {
	console.warn('formatCurrency is deprecated. Please use Alkami.CurrencyHelper.formatCurrency instead.');
	// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
	var parts = decimal.toString().split(".");

	// Add a decimal part if number is whole.
	if (parts.length == 1) {
		parts[1] = "00";
	}

	// If number is 67.5, add a 0 so it will be formatted $67.50
	if (parts[1].length == 1) {
		parts[1] = parts[1] + "0";
	}

	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return "$" + parts.join(".");
}
